import MasterTable from './MasterTable'

/* ข้อมูลหลัก → ระดับตำแหน่ง · backend: src/routes/adminBu.js

   ⚠️ ตารางในฐานชื่อ `BU` แต่เนื้อหาคือ **ระดับตำแหน่ง** (Officer, Supervisor,
      Manager, Vice President, …) ไม่ใช่หน่วยธุรกิจ — หน้านี้จึงตั้งชื่อตามของจริง
      ไม่ใช่ตามชื่อตาราง และคนละเรื่องกับ Companies.CompanyBuID
   ⚠️ รหัสแก้ไม่ได้หลังสร้าง — Users.BU_CODE อ้างอยู่โดยไม่มี FK */

type Bu = {
  BU_CODE: string
  BU_DESC: string | null
  CompanyCode: string
  inactive: boolean
  staffCount: number
}

export default function Bu() {
  return (
    <MasterTable<Bu>
      title="ระดับตำแหน่ง"
      unit="ระดับ"
      companyScoped
      addLabel="เพิ่มระดับตำแหน่ง"
      base="/api/admin/bu"
      keyOf={(r) => r.BU_CODE}
      labelOf={(r) => `${r.BU_CODE} ${r.BU_DESC ?? ''}`}
      isInactive={(r) => r.inactive}
      cols={[
        { label: 'รหัส', cell: (r) => r.BU_CODE, sortKey: 'code' },
        { label: 'ชื่อระดับตำแหน่ง', cell: (r) => r.BU_DESC ?? '-', sortKey: 'name' },
        { label: 'พนักงาน', cell: (r) => r.staffCount, num: true, sortKey: 'staff' },
      ]}
      fields={[
        { name: 'companyCode', label: 'บริษัท', required: true, lockOnEdit: true, source: 'companies' },
        { name: 'buCode', label: 'รหัส', maxLength: 100, required: true, lockOnEdit: true },
        { name: 'buDesc', label: 'ชื่อระดับตำแหน่ง', maxLength: 200 },
      ]}
      toDraft={(r) => ({
        companyCode: r.CompanyCode,
        buCode: r.BU_CODE,
        buDesc: r.BU_DESC ?? '',
      })}
    />
  )
}
